module.exports = __webpack_public_path__ + "assets/img/season4-a774b9a9.png";